import { observable, action, computed } from 'mobx'

export default class ChoicesChallenge {
  @observable selectedValue = ''
  @observable choices = []

  constructor ({ challenge }) {
    Object.assign(this, challenge)
  }

  @action setAnswer (answer) {
    this.selectedValue = answer
  }

  @computed get answer () {
    // The answer must be the index of the selected value
    const choice = this.choices.find(x => x.value === this.selectedValue)
    if (!choice) {
      return null
    }

    return this.choices.indexOf(choice)
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/ChoicesChallenge/Challenge.js